import React, { useEffect, useRef } from "react";
import strings from "translate/language";

const VideoModel = (props) => {
  const videoRef = useRef();
  useEffect(() => {
    videoRef.current?.load();
  }, [props.data?.document])
  return (
    <div>
      {" "}
      {/*add_module_start */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {/* {strings.master} */}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => { videoRef.current?.pause() }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              {props.data?.document ? (
                <video
                  ref={videoRef}
                  className="img-thumbnail"
                  controls
                  autoPlay
                  poster={props.data?.base_url + props.data?.video_thumbnail}
                >
                  <source
                    src={props.data?.base_url + props.data?.document}
                    //   src="https://itinformatix.org/justo/upload/property/property_1671513925897-611481795.mp4"
                    type="video/mp4"
                  />
                  {strings.browserNotSupport}
                </video>
              ) : (
                strings.browserNotSupport
              )}
            </div>

            <div
              className="modal-footer"
              style={{ justifyContent: "space-between" }}
            >
              <button className="btn btn-dark" type="button" onClick={() => { videoRef.current?.pause() }} data-dismiss="modal">
                {strings.back}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* add_module_end */}
    </div>
  );
};

export default VideoModel;
